// BSL-ONK §5 — Ön kayıt turları. Ekran başına en çok 3 balon, metin ≤ 140 karakter.
// Bir `data-tur` elemanı silinir/taşınırsa bu dosya aynı commit'te düzeltilir (çatı §12).
// pencere: true → sayfanın bir penceresinin turu; ? menüsü «Bu ekranı tanıt» bunu seçmez.
export default {
  onkayitListesi: {
    yol: "/musteri/onkayitform",
    adimlar: [
      { hedef: '[data-tur="onkayit-paylas"]', metin: "Müşterinizin dolduracağı formun bağlantısı burada. WhatsApp'tan, sitenizden ya da QR ile paylaşın." },
      { hedef: '[data-tur="onkayit-satir"]', metin: "Gelen başvuru buraya düşer, siz de bildirim alırsınız. Satıra tıklayıp açın." },
      { hedef: '[data-tur="onkayit-durum"]', metin: "Bekliyor: henüz yanıtlanmadı. Kabul edilen başvuru müşteri olur.", kavram: "onKayit" },
    ],
  },
  onkayitPaylas: {
    yol: "/musteri/onkayitform",
    pencere: true,
    adimlar: [
      { hedef: '[data-tur="paylas-kopyala"]', metin: "Bağlantıyı kopyalayın; her şubenin kendi bağlantısı var." },
      { hedef: '[data-tur="paylas-qr"]', metin: "QR kodunu yazdırıp girişe asabilir, gömme koduyla sitenize ekleyebilirsiniz." },
      { hedef: '[data-tur="paylas-dene"]', metin: "Formu açıp kendinize bir deneme başvurusu gönderin, sonra denemeyi Ret ile kapatın." },
    ],
  },
  onkayitDetay: {
    yol: "/musteri/onkayitform",
    pencere: true,
    adimlar: [
      { hedef: '[data-tur="onkayit-sube"]', metin: "Müşteri bu şubede açılır. Başvurunun geldiği şube seçili gelir.", kavram: "onaySube" },
      { hedef: '[data-tur="onkayit-kabul"]', metin: "Kabul edince müşteri kaydı açılır ve başvurana bilgi maili gider." },
      { hedef: '[data-tur="onkayit-ret"]', metin: "Ret edince müşteri açılmaz; başvurana yine bilgi maili gider." },
    ],
  },
};
